import { deLocalizeHref, localizeHref } from "~/paraglide/runtime";
import { assertSupportedBlogLocale } from "./blog-url";

/** Preserve query/hash while moving the same de-localized route to a locale URL. */
export function getLocaleSwitchTarget(currentHref: string, localeValue: string): string {
  const locale = assertSupportedBlogLocale(localeValue);
  return localizeHref(deLocalizeHref(currentHref), { locale });
}
